// ** MUI Components
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import MuiCard from '@mui/material/Card'

import AuthIllustrationV1Wrapper from '../login/AuthIllustrationV1Wrapper.js'
import BlankLayout from '../../Layout/blankLayout.js'
import { styled } from '@mui/material/styles'

import { useLocation, useNavigate, Link } from 'react-router-dom'

// ** Styled Components
const Card = styled(MuiCard)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { width: '25rem' }
}))

const LinkStyled = styled(Link)(({ theme }) => ({
  textDecoration: 'underlined',
  color: `${theme.palette.primary.main} !important`
}))

const ResetLink = () => {
  const location = useLocation();
  const email = location.state?.email || 'your email';
  const navigate = useNavigate(); 

  const handleReturnToLogin = () => {
    navigate('/login');
  };

  return (
    <BlankLayout>
      <Box className='content-center'>
        <AuthIllustrationV1Wrapper>
          <Card variant='outlined'>
            <CardContent sx={{ p: theme => `${theme.spacing(10.5, 8, 8)} !important` }}>
              <Box sx={{ mb: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img height='45' alt='error-illustration' src='/images/Logo2.svg' />
              </Box>
              <Box sx={{ mb: 6, textAlign: 'center' }}>
                <Typography variant='h4' sx={{ mb: 1.5 }}>
                  Reset Password
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  We've sent a recovery link to you at
                  <Typography sx={{fontWeight: 'bold'}}>{email}</Typography>
                </Typography>
              </Box>
              <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                 <Typography onClick={handleReturnToLogin} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <LinkStyled>
                      <span>Return to Log in</span>
                    </LinkStyled>
                  </Typography>
              </Box>
            </CardContent>
          </Card>
        </AuthIllustrationV1Wrapper>
      </Box>
    </BlankLayout>
  )
}

export default ResetLink
